import React from 'react';
import { authorshipPropTypes } from '@Theme/natucare/modules/Authorship/AuthorshipPropTypes';
import Container from '@Theme/natucare/components/Container/Container';
import AuthorTile from './components/AuthorTile/AuthorTile';
import * as styles from './Authorship.module.scss';
const Authorship = ({
  items,
  link,
  heading
}) => {
  if (!items && !heading && !link) {
    return null;
  }
  return /*#__PURE__*/React.createElement("section", {
    className: styles.root
  }, /*#__PURE__*/React.createElement(Container, {
    classname: styles.rootContainer
  }, heading && /*#__PURE__*/React.createElement("div", {
    className: styles.rootInfo
  }, /*#__PURE__*/React.createElement("h2", {
    className: styles.rootInfoHeading
  }, heading), (link === null || link === void 0 ? void 0 : link.label) && (link === null || link === void 0 ? void 0 : link.href) && /*#__PURE__*/React.createElement("a", {
    href: link.href,
    className: styles.rootInfoLink
  }, link.label)), items && /*#__PURE__*/React.createElement("div", {
    className: styles.rootTiles
  }, items.map((item, index) => /*#__PURE__*/React.createElement(AuthorTile, Object.assign({}, item, {
    key: index
  }))))));
};
export default Authorship;